const DEFAULTS =   {
  duration: 1000,
  done: () => {},
};

let _options = {};

const isAnimatingStyle = {
  transition: 'all 1000ms ease',
  perspective: '400px',
  display: '',
  opacity: 0,
  transform: 'rotateX(-90deg) translateZ(-75px)',
};

const inStyle = {
  opacity: 1,
  transform: 'rotateX(0deg) translateZ(0)',
};

export default function fadeIn(el, options = DEFAULTS) {
  _options = {...DEFAULTS, ...options};
  isAnimatingStyle.transition = `all ${_options.duration}ms ease`;
  _animateIn(el);
}

function _animateIn(el) {
  Object.assign(el.style, isAnimatingStyle);
  el.addEventListener('transitionend', _removeTransition);
  el.getBoundingClientRect();
  window.requestAnimationFrame(() => {
    Object.assign(el.style, inStyle);
  });
}

function _removeTransition(e) {
  Object.assign(e.target.style, {
    transition: 'none',
    transform: 'none',
  });
  e.target.removeEventListener('transitionend', _removeTransition);
  _options.done();
}
